import React, { useEffect } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  Chip,
} from "@mui/material";
import defaultProductImage from "../../assets/default-product.png";

import VerifiedIcon from "@mui/icons-material/Verified";
import { useDispatch, useSelector } from "react-redux";
import { fetchRandomProducts } from "../../features/buyer/buyerSlice";
import { useNavigate } from "react-router-dom";
import ProductCard from "../../components/buyer/ProductCard";

const RandomProductHomeSection = ( { onProductsLoaded } ) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.auth);
  const isLoggedIn = Boolean(token);
  const { products } = useSelector((state) => state.buyer);

// console.log("Products:", products);
 useEffect(() => {
    dispatch(fetchRandomProducts())
      .unwrap()
      .then(() => {
        //  Call the callback after products are loaded
        if (onProductsLoaded) onProductsLoaded();
      });
  }, [dispatch, onProductsLoaded]);


    if (!products || products.length === 0) {
    return null;
  }
  
  return (
    <Box
      sx={{
        py: { xs: 5, md: 10 },
        // background:
        //   "linear-gradient(180deg, #fff 0%, rgba(244, 197, 66, 0.03) 100%)",
        background:'#fff',
        position: "relative",
      }}
    >
      <Container maxWidth="xl">
        <Box sx={{ textAlign: "center", mb: 10 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "3rem", md: "4rem" },
              fontWeight: 900,
              mb: 4,
              color: "#2D3A27",
              letterSpacing: "-2px",
            }}
          >
            Featured Products
          </Typography>
          <Typography
            variant="h5"
            sx={{
              color: "rgba(45, 58, 39, 0.7)",
              maxWidth: "600px",
              mx: "auto",
              lineHeight: 1.6,
            }}
          >
            Explore recently listed scrap from verified sellers
          </Typography>
        </Box>

        <Grid container spacing={3} rowSpacing={4} justifyContent="center">
          {Array.isArray(products) &&
            products.map((product, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={2.4}
                key={index}
                sx={{ cursor: "pointer" }}
              >
                <ProductCard
                  product={product}
                  hideButtons={true} // hide buttons on hover
                  hideStock={true}
                  viewType="grid"
                  // customHeight={320}
                  isLoggedIn={isLoggedIn}
                />
              </Grid>
            ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default RandomProductHomeSection;
